"use client";

import { useSyncExternalStore } from "react";

/** Tailwind's `md` boundary (48rem, no custom breakpoint in globals.css), so JS and `md:` classes agree. */
const MOBILE_QUERY = "(max-width: 767px)";

/** Module-level so its identity is stable across renders. */
function subscribeToViewport(onChange: () => void): () => void {
  const mql = window.matchMedia(MOBILE_QUERY);
  // Safari < 14 uses addListener / removeListener
  if (mql.addEventListener) {
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }
  mql.addListener(onChange);
  return () => mql.removeListener(onChange);
}
function getIsMobileSnapshot(): boolean {
  return window.matchMedia(MOBILE_QUERY).matches;
}

/**
 * The server has no viewport. React uses this snapshot for BOTH the SSR render
 * and the client's hydration render, so the two cannot disagree — which is why
 * this is a store subscription and not a `useState` seeded from `matchMedia`.
 */
function getIsMobileServerSnapshot(): boolean {
  return false;
}

/** Whether the viewport is below Tailwind's `md` breakpoint; `false` during SSR and hydration. */
export function useIsMobileViewport() {
  return useSyncExternalStore(subscribeToViewport, getIsMobileSnapshot, getIsMobileServerSnapshot);
}